import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/documents/uploaded/$documentId')({})
